
import { useEffect, useState } from 'react'
import AddUpdateEmployee from './employee'
import LeftSidePopupLayout from '../modal-layout'
import AddUpdateNotice from './notice'
import { useApiCall } from '../../custom-hooks/api-call'
import { Bell, BriefcaseBusiness, Clock, Plus, XIcon } from 'lucide-react'
import AddUpdateJob from './job'
import Style from './style.module.css'

const MainPopup = ({ onClose = () => { }, onChange = () => { }, tabIndex, data }) => {
    const [navIndex, setNavIndex] = useState(tabIndex || 0);
    const [noticeType, setNoticeType] = useState([]);
    const [jobTypes, setJobTypes] = useState([]);
    const [sites, setSites] = useState([]);
    const [branches, setBranches] = useState([]);
    const [departments, setDepartments] = useState([]);
    const apiCall = useApiCall();

    const getDropdowns = async (token) => {
        try {
            const [d1, d2, d3, d4, d5] = await Promise.all([
                apiCall({ url: 'get-notice-types', method: 'get' }),
                apiCall({ url: 'get-job-types', method: 'get' }),
                apiCall({ url: 'get-job-sites', method: 'get' }),
                apiCall({ url: 'get-branches', method: 'get' }),
                apiCall({ url: 'get-depatments-heads-leads', method: 'get' })
            ]);
            setNoticeType(d1?.noticeTypeList);
            setJobTypes(d2?.jobtypeList);
            setSites(d3?.jobSiteList);
            setBranches(d4?.branchList);
            setDepartments(d5?.data)

        } catch (error) {
            console.error("Dropdown load error:", error);
        }
    };

    const handleNavClick = (index) => {
        setNavIndex(index);
    };

    useEffect(() => {
        getDropdowns();
    }, []);

    const navItems = [
        { label: "Add Employee", icon: <Plus size="1.2em" /> },
        { label: "Pending Joining", icon: <Clock size="1.2em" /> },
        { label: "Notice", icon: <Bell size="1.2em" /> },
        { label: "Job", icon: <BriefcaseBusiness size="1.2em" /> },
    ];

    return (
        <>
            <div className={Style.modal_body}>
                <LeftSidePopupLayout popupStatus={true} className={`${Style.departmentChangeModal}`}>
                    <div className={Style.modal_header}>
                        <div className={Style.modal_nav}>
                            <ul>
                                {navItems.map((item, i) => (
                                    <li
                                        key={i}
                                        className={`${navIndex === i ? Style.active : ""} ${tabIndex ? navIndex === i ? "" : Style.disabled : ""}`}
                                        onClick={() => {
                                            if (tabIndex) {
                                                if (!navIndex === i) {
                                                    handleNavClick(i);
                                                }
                                            } else {
                                                handleNavClick(i);
                                            }
                                        }}
                                    >
                                        <div className={Style.icon}>{item.icon}</div>
                                        <span>{item.label}</span>
                                    </li>
                                ))}

                                {/* {(tabIndex && tabIndex != 0) ? null :
                                    <li className={navIndex === 0 ? Style.active : null} onClick={() => { setNavIndex(0) }}>
                                        <div className={Style.icon}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                                                <path d="M11.8036 4.92857H8.16071C8.04238 4.92857 7.94643 4.83262 7.94643 4.71429V1.07143C7.94643 0.479736 7.46669 0 6.875 0C6.28331 0 5.80357 0.479736 5.80357 1.07143V4.71429C5.80357 4.83262 5.70762 4.92857 5.58929 4.92857H1.94643C1.35474 4.92857 0.875 5.40831 0.875 6C0.875 6.59169 1.35474 7.07143 1.94643 7.07143H5.58929C5.70762 7.07143 5.80357 7.16738 5.80357 7.28571V10.9286C5.80357 11.5203 6.28331 12 6.875 12C7.46669 12 7.94643 11.5203 7.94643 10.9286V7.28571C7.94643 7.16738 8.04238 7.07143 8.16071 7.07143H11.8036C12.3953 7.07143 12.875 6.59169 12.875 6C12.875 5.40831 12.3953 4.92857 11.8036 4.92857Z" fill="currentColor" />
                                            </svg>
                                        </div>
                                        <span>Add Employee</span>
                                    </li>
                                }

                                {(tabIndex && tabIndex != 1) ? null :
                                    <li className={navIndex === 1 ? Style.active : null} > 
                                        <div className={Style.icon}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                                <path d="M7.125 14C10.99 14 14.125 10.865 14.125 7C14.125 3.13499 10.99 0 7.125 0C3.25999 0 0.125 3.13499 0.125 7C0.125 10.865 3.25999 14 7.125 14ZM6.62499 3.00001C6.62499 2.725 6.84999 2.49999 7.125 2.49999C7.40001 2.49999 7.62502 2.725 7.62502 3.00001V6.76001L9.93752 8.61001C10.1525 8.78251 10.1875 9.09749 10.015 9.3125C9.91749 9.435 9.77251 9.49999 9.62499 9.49999C9.51499 9.49999 9.40498 9.46498 9.31251 9.38999L6.81252 7.39001C6.69502 7.295 6.62503 7.15251 6.62503 7L6.62499 3.00001Z" fill="currentColor" />
                                            </svg>
                                        </div>
                                        <span>Pending Joining</span>
                                    </li>
                                }

                                {(tabIndex && tabIndex != 2) ? null :
                                    <li className={navIndex === 2 ? Style.active : null} onClick={() => { setNavIndex(2) }}>
                                        <div className={Style.icon}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <path d="M13.0939 11.0227C12.9545 11.5123 12.4883 11.8591 11.9459 11.8766H1.80422C1.2618 11.8591 0.79556 11.5123 0.656162 11.0227C0.466918 10.4377 0.718306 9.80664 1.27108 9.47908C2.22224 8.87971 2.24042 8.11354 2.19195 6.81301C2.11764 5.99951 2.19242 5.18013 2.41308 4.39008C3.03103 2.50715 4.51229 1.33102 6.42067 1.16987V0.774059C6.42067 0.539844 6.6241 0.349976 6.87505 0.349976C7.12599 0.349976 7.32942 0.539844 7.32942 0.774059V1.16987C9.2378 1.33102 10.7191 2.50715 11.337 4.39008C11.5577 5.18013 11.6325 5.99951 11.5581 6.81301C11.5097 8.11353 11.5279 8.87971 12.479 9.47908C13.0318 9.80664 13.2832 10.4377 13.0939 11.0227ZM6.87505 13.6492C7.5534 13.6686 8.177 13.3033 8.45324 12.7247H5.29685C5.57309 13.3033 6.19669 13.6686 6.87505 13.6492Z" fill="currentColor" />
                                            </svg>
                                        </div>
                                        <span>Notice</span>
                                    </li>
                                }

                                {(tabIndex && tabIndex != 3) ? null :
                                    <li className={navIndex === 3 ? Style.active : null} onClick={() => { setNavIndex(3) }}>
                                        <div className={Style.icon}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 17 14" fill="none">
                                                <path d="M10.125 3.33337C9.757 3.33337 9.45833 3.03471 9.45833 2.66671V1.66671H6.79167V2.66671C6.79167 3.03471 6.493 3.33337 6.125 3.33337C5.757 3.33337 5.45833 3.03471 5.45833 2.66671V1.66671C5.45833 0.931374 6.05633 0.333374 6.79167 0.333374H9.45833C10.1937 0.333374 10.7917 0.931374 10.7917 1.66671V2.66671C10.7917 3.03471 10.493 3.33337 10.125 3.33337Z" fill="currentColor" />
                                                <path d="M8.59833 9.25337C8.47833 9.30004 8.305 9.33337 8.125 9.33337C7.945 9.33337 7.77167 9.30004 7.61167 9.24004L0.125 6.74671V11.8334C0.125 12.8467 0.945 13.6667 1.95833 13.6667H14.2917C15.305 13.6667 16.125 12.8467 16.125 11.8334V6.74671L8.59833 9.25337Z" fill="currentColor" />
                                                <path d="M16.125 4.16671V5.69337L8.285 8.30671C8.23167 8.32671 8.17833 8.33337 8.125 8.33337C8.07167 8.33337 8.01833 8.32671 7.965 8.30671L0.125 5.69337V4.16671C0.125 3.15337 0.945 2.33337 1.95833 2.33337H14.2917C15.305 2.33337 16.125 3.15337 16.125 4.16671Z" fill="currentColor" />
                                            </svg>
                                        </div>
                                        <span>Job</span>
                                    </li>
                                } */}
                            </ul>
                        </div>

                        <div
                            className={Style.close_btn}
                            style={{
                                position: 'absolute',
                                top: '-16px',
                                right: '-16px'
                            }}
                            onClick={() => { onClose() }}
                        ><XIcon size={'1em'} /></div>
                    </div>

                    {
                        navIndex === 0 && (
                            <AddUpdateEmployee
                                onClose={() => { onClose() }}
                                onChange={() => { onChange() }}
                                Style={Style}
                                data={data}
                            />
                        )
                    }

                    {
                        navIndex === 2 && (
                            <AddUpdateNotice
                                onClose={() => { onClose() }}
                                onChange={() => { onChange() }}
                                Style={Style}
                                types={noticeType}
                            />
                        )
                    }

                    {
                        navIndex === 3 && (
                            <AddUpdateJob
                                onClose={() => { onClose() }}
                                onChange={() => { onChange() }}
                                Style={Style}
                                data={data}
                                jobTypes={jobTypes}
                                sites={sites}
                                branches={branches}
                                departments={departments}
                            />
                        )
                    }
                </LeftSidePopupLayout>
            </div>
        </>
    )
}

export default MainPopup
